var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFloors(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114_712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0525 6.36105H11.9478V10.4658H16.0525V6.36105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.36108 3.3317V4.88354H10.4658V1.36022C8.97516 1.7755 7.58944 2.44869 6.36108 3.3317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4658 26.6398V23.1208H6.36108V24.6727C7.58944 25.5513 8.97516 26.2245 10.4658 26.6441V26.6398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0525 11.9476H11.9478V16.0524H16.0525V11.9476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0525 17.5342H11.9478V21.6389H16.0525V17.5342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4658 11.9476H6.36108V16.0524H10.4658V11.9476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87927 6.36105H3.32744C2.4488 7.5894 1.77561 8.97075 1.35596 10.4658H4.87927V6.36105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87916 11.9476H1.03674C0.931828 12.6165 0.875 13.3028 0.875 14.0022C0.875 14.7016 0.931828 15.3879 1.03674 16.0567H4.87916V11.952V11.9476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87905 21.6389V17.5342H1.36011C1.77539 19.0249 2.44858 20.4106 3.33159 21.6389H4.88342H4.87905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6389 11.9476H17.5342V16.0524H21.6389V11.9476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4658 17.5342H6.36108V21.6389H10.4658V17.5342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4658 6.36105H6.36108V10.4658H10.4658V6.36105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5342 1.36022V4.87916H21.6389V3.32733C20.4105 2.44869 19.0292 1.7755 17.5342 1.35585V1.36022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87919 23.1208H4.56445C4.66937 23.2257 4.77428 23.3307 4.87919 23.4356V23.1208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1208 4.87916H23.4356C23.3307 4.77425 23.2258 4.66934 23.1208 4.56442V4.87916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9478 4.87916H16.0525V1.03674C15.3836 0.931828 14.6973 0.875 13.9979 0.875C13.2985 0.875 12.6166 0.931828 11.9478 1.03674V4.87916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87919 4.87916V4.56442C4.77428 4.66934 4.66937 4.77425 4.56445 4.87916H4.87919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6389 17.5342H17.5342V21.6389H21.6389V17.5342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0525 23.1208H11.9478V26.9633C12.6166 27.0682 13.3029 27.125 13.9979 27.125C14.693 27.125 15.3836 27.0682 16.0525 26.9633V23.1208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1208 23.1208V23.4356C23.2258 23.3307 23.3307 23.2257 23.4356 23.1208H23.1208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6389 24.6727V23.1208H17.5342V26.6398C19.0248 26.2245 20.4105 25.5513 21.6389 24.6683V24.6727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9676 11.9476H23.1208V16.0524H26.9633C27.0682 15.3835 27.125 14.6972 27.125 13.9978C27.125 13.2984 27.0682 12.6121 26.9633 11.9433L26.9676 11.9476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6389 6.36105H17.5342V10.4658H21.6389V6.36105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1208 10.4658H26.6398C26.2245 8.97512 25.5513 7.5894 24.6683 6.36105H23.1165V10.4658H23.1208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6398 17.5342H23.1208V21.6389H24.6727C25.5513 20.4106 26.2245 19.0292 26.6442 17.5342H26.6398Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114_712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.25,
    height: 26.25,
    fill: "white",
    transform: "translate(0.875 0.875)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloors);
export default __webpack_public_path__ + "static/media/floors.35b305e6c4e33e4d0eda5bb5dce33053.svg";
export { ForwardRef as ReactComponent };